/**
 * Created by mykurisu on 2017/8/16.
 */
import React from 'react'
import {isLZWKAPP, judgeAPPVersion} from '../../utils'
import { goBack } from '../../utils/connectApp'
import MainEntryIcon from '../../images/liveroomSetting/liveroom-setting-entry.png'

class MainEntry extends React.Component {
    constructor() {
        super();
        this.handleToPreview = this.handleToPreview.bind(this);
    }

    handleToPreview() {
        const {liveroomId} = this.props;
        if (isLZWKAPP()) {
            goBack()
        } else {
            window.location = "/liveroom/" + liveroomId
        }
    }

    render() {
        return (
            <div className="liveroom-setting-main-entry">
                <div className="liveroom-setting-main-entry-icon">
                    <a href="javascript:;" onClick={this.handleToPreview}>
                        <img src={MainEntryIcon} alt=""/>
                    </a>
                </div>
            </div>
        )
    }

}

export default MainEntry


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainEntry.js